import React from 'react';
import LogoIntro from '../components/LogoIntro';
import InteractiveUI from '../components/InteractiveUI';

/**
 * IOTIQ Home Page — 2026 Multi-Page Experience
 * This page acts as a cinematic entry point guiding users into Residential or Industrial paths.
 */
function Home() {
  return (
    <main>
      <LogoIntro />
      <InteractiveUI />
    </main>
  );
}

export default Home;
